import React from 'react';

import css from './List.module.css';

const List = (props) => {

    let list = null;

    list = props.items.map((x, index) => <li key={index}>{x}</li>);

    const style = {
        backgroundImage: `url(${props.img})`
    };

    return (
        <div className={css.Background} style={style}>
            <div className={css.Layer}>
                <ul className={css.List}>
                    {list}
                </ul>
            </div>
        </div>
    );
};

export default List;